<template>
  <div class="container">
    <div class="info">
      <div class="title">
        <span>基本信息</span>
      </div>
      <van-cell-group>
        <van-field
          v-model="orgnamecn"
          label="组织中文名"
          required
          autosize
          rows="1"
          type="textarea"
        />
        <van-field
          v-model="orgnameen"
          label="组织英文名"
          autosize
          rows="1"
          type="textarea"
        />
        <van-field v-model="contact" label="联系人" required />
        <van-field
          v-model="conphone"
          label="联系人电话"
          required
          placeholder="建议填写座机"
        />
        <!-- <van-field v-model="orgtype" label="组织类型" required /> -->
        <van-field
          v-model="mail"
          label="邮箱"
          required
          autosize
          rows="1"
          type="textarea"
        />
        <!-- <van-field v-model="unittype" label="单位性质" required /> -->
        <van-field
          v-model="fax"
          label="传真"
          autosize
          rows="1"
          type="textarea"
        />
        <van-field
          v-model="bumen"
          label="主管部门"
          autosize
          rows="1"
          type="textarea"
        />
        <div class="list">
          <p class="label"><span style="color: red">*</span>挂靠阵地</p>
          <el-select
            v-model="orgs"
            filterable
            placeholder="请选择"
            ref="select"
            @hook:mounted="cancalReadOnly"
            @visible-change="cancalReadOnly"
          >
            <el-option
              v-for="item in options"
              v-html="item.name"
              :key="item.id"
              :label="toBlank(item.name)"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <van-field
          readonly
          required
          clickable
          label="成立日期"
          autosize
          rows="1"
          type="textarea"
          v-model="date"
          :value="date"
          @click="dayclick"
          class="border"
        />
        <van-popup v-model="dayshowPicker" round position="bottom">
          <van-datetime-picker
            @cancel="dayshowPicker = false"
            @confirm="dayonConfirm"
            v-model="currentDate"
            type="date"
            title="选择年月日"
            :min-date="minDate"
            :max-date="maxDate"
          />
        </van-popup>
        <!-- <van-field
          readonly
          autosize
          rows="1"
          type="textarea"
          label="所在城市"
          v-model="area"
          :value="area"
        /> -->
        <!-- <van-popup v-model="areashowPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="area_columns"
            value-key="name"
            @cancel="areashowPicker = false"
            @confirm="areaonConfirm"
            @change="areachange"
          />
        </van-popup> -->
        <!-- <van-field
          readonly
          clickable
          label="所在地区"
          autosize
          rows="1"
          type="textarea"
          v-model="street"
          :value="street"
          @click="streetclick"
        /> -->
        <!-- 判断是否选择了省市区 streetshowPicker = true -->
        <van-popup v-model="streetshowPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="street_columns"
            value-key="name"
            @cancel="streetshowPicker = false"
            @confirm="streetonConfirm"
            @change="streetchange"
          />
        </van-popup>
        <van-field
          v-model="intro"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          show-word-limit
          label="组织简介"
          required
        />
        <p class="label"><span style="color: red">*</span>展示图</p>
        <div class="upload">
          <!--  <el-upload
            action="/api/common/upload"
            :data="data"
            :file-list="fileList"
            :limit="1"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :class="{ disabled: uploadDisabled }"
            :on-change="handleChange"
            :on-success="success">
              <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" style="height:100%;object-fit:cover;" :src="dialogImageUrl" alt="">
          </el-dialog> -->
          <van-uploader
            :after-read="afterRead"
            :max-count="1"
            v-model="fileList"
          />
        </div>
      </van-cell-group>
    </div>
    <div class="info">
      <div class="title">
        <span>负责人信息</span>
      </div>
      <van-cell-group>
        <van-field v-model="fuzerenname" label="负责人姓名" required readonly />
        <van-field
          v-model="fuzerenphone"
          label="负责人电话"
          required
          readonly
        />
        <van-field
          v-model="fuzerenidcard"
          label="身份证号码"
          required
          autosize
          readonly
          rows="1"
          type="textarea"
        />
        <p class="label"><span style="color: red">*</span>身份证正面照片</p>
        <div class="uploadcard">
          <!--  <el-upload
            action="/api/common/upload"
            :data="data"
            :file-list="fileList2"
            :limit="1"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview2"
            :on-remove="handleRemove2"
            :class="{ disabled: uploadDisabled2 }"
            :on-change="handleChange2"
            :on-success="success2">
              <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible2">
            <img width="100%" style="height:100%;object-fit:cover;" :src="dialogImageUrl2" alt="">
          </el-dialog> -->
          <van-uploader
            :after-read="afterRead2"
            :max-count="1"
            v-model="fileList2"
          />
        </div>
        <p class="label"><span style="color: red">*</span>身份证反面照片</p>
        <div class="uploadcard">
          <!-- <el-upload
            action="/api/common/upload"
            :data="data"
            :file-list="fileList3"
            :limit="1"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview3"
            :on-remove="handleRemove3"
            :class="{ disabled: uploadDisabled3 }"
            :on-change="handleChange3"
            :on-success="success3">
              <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible3">
            <img width="100%" style="height:100%;object-fit:cover;" :src="dialogImageUrl3" alt="">
          </el-dialog> -->
          <van-uploader
            :after-read="afterRead3"
            :max-count="1"
            v-model="fileList3"
          />
        </div>
      </van-cell-group>
      <el-button type="warning" @click="submit">提交</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "createorg",
  data() {
    return {
      value: "",
      options: [],
      fileList: [],
      fileList2: [],
      fileList3: [],
      uploadDisabled: false,
      uploadDisabled2: false,
      uploadDisabled3: false,
      street_columns: [
        {
          values: [],
          defaultIndex: 0,
          className: "column1",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column2",
        },
      ],
      area_columns: [
        {
          values: [],
          defaultIndex: 0,
          className: "column1",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column2",
        },
        {
          values: [],
          defaultIndex: 0,
          className: "column3",
        },
      ],
      streetshowPicker: false,
      areashowPicker: false,
      areachoose: "320281",
      streetchoose: "",
      orgnamecn: "",
      orgnameen: "",
      contact: "",
      conphone: "",
      mail: "",
      fax: "",
      bumen: "",
      orgs: "",
      date: "",
      daychoose: "",
      currentDate: new Date(),
      maxDate: new Date(),
      minDate: new Date(2000, 0, 1),
      dayshowPicker: false,
      area: "江苏省江阴市",
      street: "江苏省江阴市",
      intro: "",
      fuzerenname: "",
      fuzerenphone: "",
      fuzerenidcard: "",
      dialogImageUrl: "",
      dialogVisible: false,
      dialogImageUrl2: "",
      dialogVisible2: false,
      dialogImageUrl3: "",
      dialogVisible3: false,
      data: { token: sessionStorage.getItem("wmtoken") },
      url: "",
      appId: "2312",
    };
  },
  created() {
    var that = this;
    this.url = "//zhuzhan.ijiangyin.com/siteapp/appClient/sign";
    zjyapi.init({
      appId: that.appId,
      error: function (code, ret) {
        //失败回调,默认
        alert("初始化失败");
      },
      success: function success(ret) {
        that.queryUserInfoAll();
      },
    });
    this.$axios({
      method: "post",
      url: "/api/org/sj_tree",
      data: this.qs.stringify({
        token: sessionStorage.getItem("wmtoken"),
      }),
    }).then((res) => {
      console.log(res.data);
      if (res.data.code == 0) {
        this.options = res.data.data;
      }
    });
    /* this.$axios({
      method:'post',
      url:'/api/common/area',
      data:this.qs.stringify({
        code:''
      })
    }).then(res => {
      console.log(res.data);
      if(res.data.code == 0){
        that.area_columns[0].values = res.data.data;
        that.area_columns[0].defaultIndex = 9;
        that.locate(that.area_columns[0].values[9].code).then(res => {
          that.area_columns[1].values = res;
          that.area_columns[1].defaultIndex = 1;
          that.locate(that.area_columns[1].values[1].code).then(res => {
            console.log(res);
            that.area_columns[2].values = res;
            that.area_columns[2].defaultIndex = 5;
            that.locate(that.area_columns[2].values[5].code).then(res => {
              that.street_columns[0].values = res;
              that.locate(that.street_columns[0].values[0].code).then(res => {
                that.street_columns[1].values = res;
              })
            })
          })
        })
      }
    }) */
    this.locate("320281").then((res) => {
      that.street_columns[0].values = res;
      that.locate(that.street_columns[0].values[0].code).then((res) => {
        //that.street_columns[1].values = res;
        that.street_columns[0].values.unshift({ code: "", name: "不选择" });
        that.street_columns[1].values.unshift({ code: "", name: "不选择" });
        console.log(that.street_columns);
      });
    });
  },
  mounted() {
    /* Array.from(document.getElementsByClassName('el-select')).forEach((item) => {
      item.children[0].children[0].removeAttribute('readOnly')
      item.children[0].children[0].onblur = function () {
        let _this = this
        setTimeout(() => {
          _this.removeAttribute('readOnly')
        }, 200)
      }
    }) */
  },
  methods: {
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中";
      let formData = new FormData();
      formData.append("file", file.file);
      this.$axios
        .post("/api/common/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          console.log(res.data);
          console.log(this.fileList);
          this.fileList[this.fileList.length - 1].url = res.data.data.url;
          file.status = "done";
        });
    },
    afterRead2(file) {
      file.status = "uploading";
      file.message = "上传中";
      let formData = new FormData();
      formData.append("file", file.file);
      this.$axios
        .post("/api/common/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          console.log(res.data);
          console.log(this.fileList2);
          this.fileList2[this.fileList2.length - 1].url = res.data.data.url;
          file.status = "done";
        });
    },
    afterRead3(file) {
      file.status = "uploading";
      file.message = "上传中";
      let formData = new FormData();
      formData.append("file", file.file);
      this.$axios
        .post("/api/common/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          console.log(res.data);
          console.log(this.fileList3);
          this.fileList3[this.fileList3.length - 1].url = res.data.data.url;
          file.status = "done";
        });
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    queryUserInfoAll: function () {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.queryUserInfoAll({
          sign: sign,
          params: {
            type: "2",
          },
          success: function (ret) {
            console.log("获取用户信息成功：" + ret);
            var data = JSON.parse(ret);
            that.fuzerenphone = data.mobile;
            that.fuzerenidcard = data.identityId;
            that.fuzerenname = data.authenticationName;
            console.log(ret);
            console.log(JSON.parse(ret));
          },
          error: function (error) {
            console.log("获取用户信息失败：" + JSON.stringify(error));
          },
        });
      });
    },
    //end
    //app相关结束
    dayclick() {
      this.dayshowPicker = true;
    },
    dayonConfirm(val) {
      this.dayshowPicker = false;
      Date.prototype.format = function (fmt) {
        var o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "h+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          S: this.getMilliseconds(), //毫秒
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
        }
        return fmt;
      };
      console.log(val.format("yyyy-MM-dd"));
      this.date = val.format("yyyy-MM-dd");
      this.daychoose = val.format("yyyy-MM-dd");
    },
    toBlank(str) {
      let data = encodeURI(str);
      data = data.replace(/&nbsp;/gi, "");
      return decodeURI(data);
    },
    streetclick() {
      /* if(this.area == ''){
        this.$toast('请先选择省市区');
        return;
      } */
      this.streetshowPicker = true;
    },
    handleRemove(file, fileList) {
      console.log(file);
      this.fileList = fileList;
      this.uploadDisabled = false;
    },
    handleChange(file, fileList) {
      if (fileList.length >= 1) {
        this.uploadDisabled = true;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    success(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      this.fileList = fileList;
    },
    handleRemove2(file, fileList) {
      console.log(file);
      this.fileList2 = fileList;
      this.uploadDisabled2 = false;
    },
    handleChange2(file, fileList) {
      if (fileList.length >= 1) {
        this.uploadDisabled2 = true;
      }
    },
    handlePictureCardPreview2(file) {
      this.dialogImageUrl2 = file.url;
      this.dialogVisible2 = true;
    },
    success2(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      this.fileList2 = fileList;
    },
    handleRemove3(file, fileList) {
      console.log(file);
      this.fileList3 = fileList;
      this.uploadDisabled3 = false;
    },
    handleChange3(file, fileList) {
      if (fileList.length >= 1) {
        this.uploadDisabled3 = true;
      }
    },
    handlePictureCardPreview3(file) {
      this.dialogImageUrl3 = file.url;
      this.dialogVisible3 = true;
    },
    success3(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      this.fileList3 = fileList;
    },
    //查询省市区
    locate(code) {
      return this.$axios({
        method: "post",
        url: "/api/common/area",
        data: this.qs.stringify({
          code: code,
          token: sessionStorage.getItem("wmtoken"),
        }),
      }).then((res) => {
        //console.log(res.data);
        if (res.data.code == 0) {
          return res.data.data;
        }
      });
    },
    streetonConfirm(value, index) {
      let arr = [];
      for (let i in value) {
        if (value[i].code != "") {
          arr.push(value[i].name);
        }
      }
      this.street = "江苏省江阴市  " + arr.join("/");
      this.streetshowPicker = false;
      console.log(value);
      this.streetchoose = value[0].code;
      this.villagechoose = value[1].code;
    },
    streetchange(picker, value, index) {
      if (value[0].code != "") {
        this.locate(value[0].code).then((res) => {
          res.unshift({ code: "", name: "不选择" });
          picker.setColumnValues(1, res);
          this.street_columns[1].defaultIndex = 0;
        });
      } else {
        picker.setColumnValues(1, [{ code: "", name: "不选择" }]);
        this.street_columns[1].defaultIndex = 0;
      }
    },
    areaonConfirm(value, index) {
      console.log(value);
      let arr = [];
      for (let i in value) {
        arr.push(value[i].name);
      }
      this.area = arr.join("/");
      this.areashowPicker = false;
      console.log(index);
      this.areachoose = value[2].code;
      var that = this;
      this.street = "";
      this.streetchoose = "";
      this.locate(this.areachoose).then((res) => {
        that.street_columns[0].values = res;
        that.locate(that.street_columns[0].values[0].code).then((res) => {
          that.street_columns[1].values = res;
        });
      });
    },
    areachange(picker, value, index) {
      console.log(value, index);
      this.locate(value[0].code).then((res) => {
        picker.setColumnValues(1, res);
        this.area_columns[1].defaultIndex = 0;
        this.locate(picker.getValues()[1].code).then((res) => {
          picker.setColumnValues(2, res);
          this.area_columns[2].defaultIndex = 0;
        });
      });
    },
    submit() {
      if (this.orgnamecn == "") {
        this.$toast("请填写组织中文名");
        return;
      }
      if (this.contact == "") {
        this.$toast("请填写联系人");
        return;
      }
      if (this.conphone == "") {
        this.$toast("请填写联系人电话");
        return;
      }
      if (this.mail == "") {
        this.$toast("请填写邮箱");
        return;
      }
      /* if(this.bumen == ''){
        this.$toast('请填写主管部门');
        return;
      } */
      if (this.orgs == "") {
        this.$toast("请选择挂靠阵地");
        return;
      }
      if (this.date == "") {
        this.$toast("请输入成立日期");
        return;
      }
      /* if(this.streetchoose == ''){
        this.$toast('请选择所在地区');
        return;
      } */
      if (this.intro == "") {
        this.$toast("请填写简介");
        return;
      }
      if (this.fileList.length == 0) {
        this.$toast("请上传展示图");
        return;
      } else {
        if (this.fileList[0].status != "done") {
          this.$toast("尚有文件上传中，请稍候");
          return;
        }
      }
      if (this.fuzerenname == "") {
        this.$toast("请填写负责人姓名");
        return;
      }
      if (this.fuzerenphone == "") {
        this.$toast("请填写负责人电话");
        return;
      }
      if (this.fuzerenidcard == "") {
        this.$toast("请填写负责人身份证号码");
        return;
      }
      if (this.fileList2.length == 0) {
        this.$toast("请上传身份证正面照片");
        return;
      } else {
        if (this.fileList2[0].status != "done") {
          this.$toast("尚有文件上传中，请稍候");
          return;
        }
      }
      if (this.fileList3.length == 0) {
        this.$toast("请上传身份证反面照片");
        return;
      } else {
        if (this.fileList3[0].status != "done") {
          this.$toast("尚有文件上传中，请稍候");
          return;
        }
      }
      this.$axios({
        method: "post",
        url: "/api/org/ruzhu",
        data: this.qs.stringify({
          img: this.fileList[0].url,
          pid: this.orgs,
          create_date: this.date,
          name: this.orgnamecn,
          name_en: this.orgnameen,
          contact_name: this.contact,
          contact_mobile: this.conphone,
          fuze_name: this.fuzerenname,
          fuze_mobile: this.fuzerenphone,
          fuze_cert: this.fuzerenidcard,
          fuze_cert_img1: this.fileList2[0].url,
          fuze_cert_img2: this.fileList3[0].url,
          intro: this.intro,
          area: this.areachoose,
          street: this.streetchoose,
          village: this.villagechoose,
          email: this.mail,
          chuanzhen: this.fax,
          bumen: this.bumen,
          token: sessionStorage.getItem("wmtoken"),
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.$toast("已提交申请");
          this.$router.push("/orginazation");
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.info {
  margin-bottom: 10px;
  padding: 10px;
}
.title {
  background: #f4f4f4;
  height: 25px;
}
.title span {
  background: #cab586;
  color: white;
  width: 35%;
  text-align: center;
  line-height: 25px;
  height: 25px;
  display: inline-block;
}
.el-button {
  background: #cab586;
  border: 0;
  margin: 20px auto;
  display: block;
  width: 50%;
}
.list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
}
.el-select {
  width: 100%;
}
.label {
  font-size: 14px;
  line-height: 24px;
  padding-left: 8px;
  white-space: nowrap;
  margin-right: 10px;
}
.upload /deep/ .el-upload--picture-card {
  width: 25vw;
  height: 25vw;
  line-height: 25vw;
}
.upload /deep/ .el-upload-list__item {
  width: 25vw;
  height: 25vw;
  line-height: 25vw;
}
.upload
  /deep/
  .el-upload-list--picture-card
  .el-upload-list__item-status-label
  i {
  font-size: 0;
}
.uploadcard /deep/ .el-upload--picture-card {
  width: 50vw;
  height: 25vw;
  line-height: 25vw;
}
.uploadcard /deep/ .el-upload-list__item {
  width: 50vw;
  height: 25vw;
  line-height: 25vw;
}
.uploadcard
  /deep/
  .el-upload-list--picture-card
  .el-upload-list__item-status-label
  i {
  font-size: 0;
}
</style>
<style>
.el-select-dropdown {
  left: 10vw !important;
  max-width: 80vw;
}
.disabled .el-upload--picture-card {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/createorg.vue